import { Directive, EventEmitter, Input, Output, ViewContainerRef } from '@angular/core';

import { CardContent, CardModel } from 'src/app/interfaces/views.interface';

@Directive({
  selector: '[card-host]',
})
export class CardDirective implements CardContent {
  @Input({ required: false }) public card: CardModel;
  @Input({ required: false }) public index: number;

  @Output() public action: EventEmitter<string> = new EventEmitter<string>();

  public constructor(public viewContainerRef: ViewContainerRef) {}
}
